import React, { type HTMLAttributes, type PropsWithChildren } from "react";

import * as S from "src/components/FormV2/FormToolbar/FormToolbar.style.ts";

import { formClasses } from "src/components/FormV2/Form.constants.ts";
import { useFormContext } from "src/components/FormV2/useFormContext.ts";

export const FormToolbar = ({
  children,
  ...restProps
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  const { hasScrolled, disableToolbarAnimation } = useFormContext();
  return (
    <S.Toolbar
      $disableAnimation={disableToolbarAnimation}
      $hasScrolled={hasScrolled}
      className={formClasses.toolbar}
      {...restProps}
    >
      <S.ToolbarInner>{children}</S.ToolbarInner>
    </S.Toolbar>
  );
};
